'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    footer: {
      padding: '20px 10px' // TODO use units and spacing
    },
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
};

exports.default = styles;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-layout/lib/components/Footer/styles.js
// module id = 610
// module chunks = 61549186969478 79611799117203